// extracted by mini-css-extract-plugin
export default {"videoIcon":"_fc63351b","hideVideoIcon":"_7e1d897b"};